import type { FocusedInboxOptionStateMap } from './schema/FocusedInboxOptionState';
import type FocusedInboxOptionState from './schema/FocusedInboxOptionState';
import { createStore } from 'owa-satcheljs';
export function defaultFocusedInboxOptionState(): FocusedInboxOptionState {
    return {
        isEnabled: null,
    };
}

const defaultExport: () => FocusedInboxOptionStateMap = createStore<FocusedInboxOptionStateMap>(
    'focusedInboxOption',
    {
        entries: new Map(),
    }
);
export default defaultExport;
